@if ((control?.dirty || control?.touched) && control?.errors !== null) {
  @for (error of control?.errors | keyvalue; track error) {
    <smallstack-i18n data="@@errors.validations.{{ error.key }}" [replacers]="error.value" />
  }
}
